/**
 * Inserts the value `value` into array `array` at index `index`.
 * The original array is shallow copied and is not modified.
 * @param array Array to insert into
 * @param index Index to insert at
 * @param value Value to insert
 * @returns Shallow copy of array with value inserted at given index
 */
export function insertIntoArray<T>(array: T[], index: number, value: T): T[] {
  const copy = [...array];
  copy.splice(index, 0, value);
  return copy;
}
